(function () {
  'use strict';

  var pop = document.querySelector('.neon-pop');
  if (!pop) return;

  var card = pop.querySelector('.neon-pop__card');
  var STORAGE_KEY = 'bf_promo_popup_seen';

  var delay = parseInt(pop.dataset.delay, 10);
  if (isNaN(delay)) delay = 8;

  var frequency = pop.dataset.frequency || 'once_days';
  var days = parseInt(pop.dataset.days, 10);
  if (isNaN(days) || days < 1) days = 7;

  var designMode = pop.dataset.designMode === '1';

  /* ==========================================================================
     MAG HIJ GETOOND WORDEN?
     In de theme editor altijd, anders kun je hem niet bewerken. Daarbuiten
     bepaalt de ingestelde frequentie het.
     ========================================================================== */

  function alreadySeen() {
    if (designMode) return false;

    try {
      if (frequency === 'every_visit') return false;

      if (frequency === 'once_session') {
        return sessionStorage.getItem(STORAGE_KEY) === '1';
      }

      // once_days
      var last = parseInt(localStorage.getItem(STORAGE_KEY), 10);
      if (isNaN(last)) return false;
      return Date.now() - last < days * 86400000;
    } catch (e) {
      // Privémodus of geblokkeerde opslag: dan liever één keer tonen
      // dan de bezoeker op elke pagina lastigvallen.
      return false;
    }
  }

  function remember() {
    if (designMode) return;
    try {
      if (frequency === 'once_session') {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } else if (frequency === 'once_days') {
        localStorage.setItem(STORAGE_KEY, String(Date.now()));
      }
    } catch (e) {}
  }

  if (alreadySeen()) return;

  /* ==========================================================================
     OPENEN EN SLUITEN
     ========================================================================== */

  var lastFocused = null;

  function open() {
    lastFocused = document.activeElement;
    pop.hidden = false;
    // eerst zichtbaar maken, dan pas animeren
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        var first = pop.querySelector('.neon-pop__close');
        if (first) first.focus();
      });
    });
    remember();
  }

  function close() {
    pop.classList.remove('is-open');
    setTimeout(function () {
      pop.hidden = true;
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }, 250);
  }

  pop.querySelectorAll('[data-pop-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });

  // Klik naast het venster sluit ook
  pop.addEventListener('click', function (e) {
    if (e.target === pop) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) close();
  });

  // Tabben blijft binnen het venster zolang hij openstaat
  pop.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || pop.hidden) return;
    var focusable = card.querySelectorAll('button, a[href], input, select, textarea');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  setTimeout(open, delay * 1000);
})();
